var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_184_248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16.5,
    r: 16,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 11.8594H12.7031L13.2727 10.2633C13.312 10.1541 13.3841 10.0597 13.4791 9.99296C13.5741 9.92626 13.6874 9.89052 13.8035 9.89063H19.1965C19.4338 9.89063 19.6465 10.04 19.7256 10.2633L20.2969 11.8594H22.6875C23.4645 11.8594 24.0938 12.4887 24.0938 13.2656V21.2812C24.0938 22.0582 23.4645 22.6875 22.6875 22.6875H10.3125C9.53555 22.6875 8.90625 22.0582 8.90625 21.2812V13.2656C8.90625 12.4887 9.53555 11.8594 10.3125 11.8594ZM10.1719 21.2812C10.1719 21.3586 10.2352 21.4219 10.3125 21.4219H22.6875C22.7648 21.4219 22.8281 21.3586 22.8281 21.2812V13.2656C22.8281 13.1883 22.7648 13.125 22.6875 13.125H19.4057L19.1051 12.2848L18.7025 11.1563H14.2992L13.8967 12.2848L13.5961 13.125H10.3125C10.2352 13.125 10.1719 13.1883 10.1719 13.2656V21.2812ZM16.5 14.25C18.0539 14.25 19.3125 15.5086 19.3125 17.0625C19.3125 18.6164 18.0539 19.875 16.5 19.875C14.9461 19.875 13.6875 18.6164 13.6875 17.0625C13.6875 15.5086 14.9461 14.25 16.5 14.25ZM16.5 18.75C17.4316 18.75 18.1875 17.9941 18.1875 17.0625C18.1875 16.1309 17.4316 15.375 16.5 15.375C15.5684 15.375 14.8125 16.1309 14.8125 17.0625C14.8125 17.9941 15.5684 18.75 16.5 18.75Z",
    fill: "#748ADF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_184_248",
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_184_248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_184_248",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.05060dbef1a224c974add6b60a32bb04.svg";
export { ForwardRef as ReactComponent };